import { Component, Input, HostBinding } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

@Component({
  selector: 'ng-casto-btn',
  templateUrl: './btn.component.html',
})
export class BtnComponent {
  @HostBinding('class.isLoading') get isLoading() {
    return this.loading;
  }
  @HostBinding('class.disabled') get isDisabled() {
    return this.disabled;
  }
  @HostBinding('class.active') get isActive() {
    return this.active;
  }
  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() label: string;
  @Input() active: boolean = false;

  /** Icône optionnelle de la librairie font awesome */
  @Input() faIcon?: IconDefinition;
  /** Font size de l'icône optionnelle, medium par défaut. */
  @Input() faSize?: string = 'medium';

  constructor() {}

  disabledAreaClick(e: Event) {
    e.stopPropagation();
    e.preventDefault();
  }
}
